export default function truncate(input, length) {
    let size = this._.size(input);
    if(input != null && size > length) return input.substring(0, length) + '...';
    else return input;
}